import React, { Component } from "react";
import styled from "styled-components";
import { colors, soloHoras, restanteHoras } from "../utils/helpers";

export default class Itinerario extends Component {
	render() {
		const ContenedorItinerario = styled.div`
			border-left: 2px solid ${colors.grisclaro};
		`;

		const Marker = styled.div`
			padding-left: 2em;
		`;

		const Marcador = styled.h2`
			color: ${colors.ss};
			font-size: 1.2em;
			margin: 0;
			padding: 0.1em 0;
			&&:before {
				display: block;
				content: "";
				width: 18px;
				height: 18px;
				border-radius: 50%;
				background: ${colors.white};
				border: 4px solid ${colors.ss};
				transform: translate(-2.2em, 1em);
			}
		`;

		const MarcadorGrande = Marcador.extend`
			letter-spacing: 0.02em;
			&&:before {
				display: none;
			}
		`;

		const Hora = styled.h3`
			margin: 0;
			padding: 0.1em 0;
		`;

		const HoraRelativa = styled.h4`
			color: ${colors.main};
			margin: 0;
			padding: 0.1em 0;
			font-weight: 400;
		`;
		const List = styled.ul`
			list-style-type: none;
		`;
		const ListItem = styled.li`
			border-bottom: 1px solid ${colors.grisclaro};
			margin: 0;
			padding: 0.4em 0 0.4em 0;
		`;

		const hacerLista = () => {
			let it = this.props.pro_obj.markers.map((x, i) => {
				return (
					<div key={(x, i)}>
						<Marker>
							{x.name === "Salida" ? (
								<MarcadorGrande>SALIDA</MarcadorGrande>
							) : (
								<Marcador>{x.name}</Marcador>
							)}
							<Hora>{restanteHoras(x.hora)}</Hora>
							{this.props.dia === this.props.dia_act && (
								<HoraRelativa>{soloHoras(x.hora)}</HoraRelativa>
							)}
						</Marker>
						<List>
							{this.props.pro_obj.itinerario[i].map((x, i) => (
								<ListItem key={x + i}>{x}</ListItem>
							))}
						</List>
					</div>
				);
			});
			return (
				<div>
					{it}
					<Marker>
						<MarcadorGrande>RECOGIDA</MarcadorGrande>
					</Marker>
				</div>
			);
		};

		return (
			<ContenedorItinerario>
				<div>{hacerLista()}</div>
			</ContenedorItinerario>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Itinerario.js